var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-contact',{attrs:{"entity":_vm.value.sender,"countryEndpoint":'customer/countries/sender'},on:{"update:entity":val => _vm.update(val),"validate":val => _vm.unlock(val)}})
}
var staticRenderFns = []

export { render, staticRenderFns }